module.exports = __webpack_public_path__ + "media/win1.19b6e9db.mp3";